import type { User } from '@/models/User/Model'
import axios from 'axios'

const backendUrl = import.meta.env.VITE_BACKEND_URL

export interface RequestPasswordResetParams {
	email: string
}

export interface ResetPasswordParams {
	email: string
	token: string
	password: string
	password_confirmation: string
}

export interface OauthConsentResult {
	redirect_url: string
}

export default class AuthApi {
	login({
		email,
		password,
		remember = false,
	}: {
		email: string
		password: string
		remember?: boolean
	}) {
		return axios.post<User>(backendUrl + '/login', { email, password, remember })
	}

	logout() {
		return axios.post(backendUrl + '/logout')
	}

	getUser() {
		return axios.get<User>(backendUrl + '/user')
	}

	register({
		email,
		password,
		password_confirmation,
		accepts_toc,
	}: {
		email: string
		password: string
		password_confirmation: string
		accepts_toc: boolean
	}) {
		return axios.post(backendUrl + '/register', {
			email,
			password,
			password_confirmation,
			name: email,
			accepts_toc,
		})
	}

	async verifyEmail({
		id,
		hash,
		expires,
		signature,
	}: {
		id: string
		hash: string
		expires: string
		signature: string
	}) {
		await axios.get(backendUrl + `/email/verify/${id}/${hash}`, {
			params: { expires, signature },
		})
		await this.getUser()
	}

	resendEmailVerification() {
		return axios.post(backendUrl + '/email/verification-notification')
	}

	githubLoginRedirect() {
		window.location.href = backendUrl + '/auth/github/redirect'
	}

	googleLoginRedirect() {
		window.location.href = backendUrl + '/auth/google/redirect'
	}

	requestPasswordReset(params: RequestPasswordResetParams) {
		return axios.post(backendUrl + '/forgot-password', params)
	}

	resetPassword(params: ResetPasswordParams) {
		return axios.post(backendUrl + '/reset-password', params)
	}

	oauthApprove() {
		return axios.post<OauthConsentResult>(backendUrl + '/auth/oauth/approve')
	}

	oauthDeny() {
		return axios.post<OauthConsentResult>(backendUrl + '/auth/oauth/deny')
	}
}
